// disable due to legacy code patterns that are not worth refactoring at this time
// oxlint-disable react-compiler/refs
import {
  type RefObject,
  Children,
  type ReactNode,
  useEffect,
  type ChangeEvent,
  isValidElement,
} from 'react'
import styled from 'styled-components'
import { type OptionProps } from '@/features/shared/components/Dropdown/Option'

type Props = {
  buttonRef: RefObject<HTMLButtonElement | null>
  onChange: (value: string) => void
  onClose: () => void
  children: ReactNode
}

export const MobileDropdown = ({ buttonRef, onChange, onClose, children }: Props) => {
  useEffect(() => {
    const setButtonRefTabIndex = (tabIndex: string) => {
      // disables parent button a11y that this <select> component overlays
      // so that only native select is tabbable and focusable
      buttonRef.current?.setAttribute('tabindex', tabIndex)
    }

    setButtonRefTabIndex('-1')
    return () => {
      setButtonRefTabIndex('0')
    }
  }, [buttonRef])

  const handleOptionChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value)
    onClose()
    // lastly, maintain focus on native select
    event.target.focus()
  }

  const height = buttonRef.current?.clientHeight ?? 50

  return (
    <Wrapper>
      <QuantitySelector
        aria-label="Select product quantity"
        onChange={handleOptionChange}
        onBlur={onClose}
        height={height}
      >
        {Children.map(
          children,
          (option) =>
            isValidElement<OptionProps<string>>(option) && (
              <option
                value={option.props.value}
                selected={option.props.selected}
                disabled={option.props.disabled}
              >
                {option.props.label || option.props.value}
              </option>
            ),
        )}
      </QuantitySelector>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  opacity: 0;
`

const QuantitySelector = styled.select<{ height: number }>`
  width: 100%;
  height: ${({ height }) => height}px;
`
